module.exports = __webpack_public_path__ + "static/media/LATMALCOTKITX4.30f5960e.png";